module.exports = __webpack_public_path__ + "img/clickList.7fd54283.png";